$(document).ready(function(){
  
    const loader = $('#compare-loader');
    const params = window.location.href.split('?')[1].split('&');
    const page_title = $('h1.page-title');
    const compare_header = $('#compare-header');
    const compare_back_link = $('#compare-back-link');
    const compare_back_link_text = $('#compare-back-link-text');
    const compare_no_products_back_link = $('#compare-no-products-back-link');
    const compare_no_products_back_link_text = $('#compare-no-products-back-link-text');
    const compare_no_products_text_link = $('#compare-no-products-text-link');
    const compare_no_products_container = $('#compare-no-products');
    const compare_content_container = $('#compare-content');
    const compare_products_list = $('#compare-products-list');
    const email_link = $('#compare-email-link');
    const sticky_hook = document.querySelector('[data-sticky-hook]');
    const sticky_start = sticky_hook.getBoundingClientRect().y;
    const differences_toggl = $('#highlight-differences');
    const tooSmallBreakpoint = 1000;
    var email_href = email_link.attr('href');
    var products = [];
    var collection_name = '';
    var collection_handle = '';
    var specs_rows = [];
    var num_products = 4;
    
    params.forEach((param) => {
      if (param.search('c=') >= 0) {
        collection_name = param.replace(/_/g, ' ').replace('c=', '');
        page_title.text(`Compare ${collection_name}`);
        compare_back_link_text.text(`Go back to ${collection_name}`);
        compare_no_products_back_link_text.text(`Go back to ${collection_name}`);
        compare_no_products_text_link.text(`Go back to ${collection_name}`);
        $('#compare-back-link-text-tooSmall').text(`Go back to ${collection_name}`);
      }
      else if (param.search('h=') >= 0) {
        collection_handle = param.replace('h=', '');
        console.log(collection_handle);
        compare_back_link.attr('href', `/collections/${collection_handle}`);
        compare_no_products_back_link.attr('href', `/collections/${collection_handle}`);
        compare_no_products_text_link.attr('href', `/collections/${collection_handle}`);
        $('#compare-back-link-tooSmall').attr('href', `/collections/${collection_handle}`);
      }
      else {
        products.push(param);
      }
    });
    
    email_link.attr('href', email_href + ' %0D%0A%0D%0A' + encodeURIComponent(window.location.href)); 
    
    console.log(sticky_hook.getBoundingClientRect());
    
    function fix_sticky()
    {
      if ($(window).scrollTop() > sticky_start) 
      {
        $('.compare-sticky').show();
      } 
      else 
      { 
        $('.compare-sticky').hide();
      }
    }

    function tooSmall()
    {
      if (window.innerWidth < tooSmallBreakpoint) {
        $('#compare-tooSmall').show();
        $('#compare-no-products').hide();
        $('#compare-header').hide();
        $('#compare-content').hide();
      } else {
        $('#compare-tooSmall').hide();
        if (num_products == 0) {
          $('#compare-no-products').show();
          $('#compare-header').hide();
          $('#compare-content').hide();
        } else {
          $('#compare-no-products').hide();
          $('#compare-header').show();
          $('#compare-content').show();
        }
      }
    }
    
    function decodeHTML(string) {
      return string.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#039;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    }
    
    function highlightDifferences() {
      let prices = $('[data-compare-diff-price]:not([style*="display: none;"])');
      for (let i=0; i < prices.length; i++) {
        let check_price = prices[i].children[0].textContent;
        let has_match = false;
        for (let j=0; j < prices.length; j++) {
          if (i!=j && prices[j].children[0].textContent == check_price) {
            has_match = true;
          }
        }
        if (!has_match) {
          prices[i].classList.toggle('compare-diff-highlight');
        }
        else {
          prices[i].classList.remove('compare-diff-highlight');
        }
      }
      
      let features = $('[data-compare-diff-features]:not([style*="display: none;"])');
      for (let i=0; i < features.length; i++) {
        let check_cell = features[i].children[0].innerHTML;
        let has_match = false;
        for (let j=0; j < features.length; j++) {
          if (i!=j && features[j].children[0].innerHTML == check_cell) {
            has_match = true;
          }
        }
        if (!has_match) {
          features[i].classList.toggle('compare-diff-highlight');
        }
        else {
          features[i].classList.remove('compare-diff-highlight');
        }
      }
      
      let specs_col = $('[data-compare-diff-specs]:not([style*="display: none;"])');
      console.log(specs_col);
      for (let i=0; i < specs_col.length; i++) {
        for (let k=0; k < specs_col[i].children.length; k++ ) {
          let check_cell = specs_col[i].children[k].textContent;
          let all_same = true;
          for (let j=0; j < specs_col.length; j++) {
            if (i!=j && specs_col[j].children[k].textContent != check_cell) {
              all_same = false;
            }
          }
          if (!all_same) {
            specs_col[i].children[k].classList.toggle('compare-diff-highlight');
          }
          else {
            specs_col[i].children[k].classList.remove('compare-diff-highlight');
          }
        }
      }
    }
    
    function equalSpecsHeights(spec) {
      let spec_row = document.querySelectorAll(`[data-spec="${spec}"]`);
      var heights_array = [];
      spec_row.forEach((cell) => {
        let cell_height = cell.clientHeight;
        if (cell_height > 55) {
          heights_array.push(cell_height);
        }
        else {
          heights_array.push(55);
        }
      });
      var biggest_height = Math.max.apply(null, heights_array); 
      spec_row.forEach((cell) => {
        cell.style.height = `${biggest_height}px`;
      });
    }
   
    $.ajax({
      type: 'POST',
      url: 'https://etempashopifyapps.co.uk/mcsport/includes/php/compare/compare_query.php',
      data: {
        products: products
      },
      success: function(response){
        console.log(response);
        response.products.forEach((product) => {
  
          let body_html = decodeHTML(product.body_html);
  
          let features_start = body_html.indexOf('<ul');
          let features_end = body_html.indexOf('</ul>');
          if (features_start != -1 && features_end != -1) {
            let features_html = body_html.slice(features_start, features_end) + '</ul>';
            product.features = features_html;
          }
          else {
            product.features = ' '; 
          }
  
          let specs = [];
          let specs_start = body_html.indexOf('<table');
          let specs_end = body_html.indexOf('</table>');
          if (specs_start != -1 && specs_end != -1) {
            let specs_html = body_html.slice(specs_start, specs_end) + '</table>';
            let temp_table = document.createElement('div');
            temp_table.innerHTML = specs_html;
            let rows = temp_table.querySelectorAll('tr');
            rows.forEach((row) => {
              if (row.cells.length > 0) {
                let row_name = row.cells[0].innerText.replace(/\n/g, '');
                let row_value = row.cells[1].innerText.replace(/\n/g, '').trim();
                specs.push({
                  name: row_name,
                  value: row_value
                });
                if (!specs_rows.includes(row_name)) {
                  specs_rows.push(row_name);
                }
              }
            });
            product.specs = specs;
          }
        });
        
        console.log(specs_rows);
  
        specs_rows.forEach((spec) => {
          let spec_div = document.createElement('div');
          let col_div = document.createElement('div');
          spec_div.classList.add('compare-border-dark');
          col_div.classList.add('compare-border');
          spec_div.innerText = spec;
          spec_div.setAttribute('data-spec', spec);
          col_div.setAttribute('data-spec', spec);
          $('[data-specs-sidebar]').append(spec_div);
          $('.specs-col').append(col_div);
        });
  
        num_products = response.products.length;
        if (num_products < 4) {
          for (let i = 3; i >= num_products ; i--) {
            $(`[data-col-${i}]`).hide();
            $('.compare-page-grid').addClass(`compare-grid-${num_products}`);
            $('.compare-expand').css('grid-column', `span ${num_products + 1}`);
            $('.compare-featspec-grid').css('grid-column', `span ${num_products + 1}`);
          }
        }
  
        if (num_products > 1) {
          response.products.sort(function(a, b) {
            let priceA = a.variant_price;
            var priceB = b.variant_price;
            if (priceA < priceB) {
              return -1;
            }
            if (priceA > priceB) {
              return 1;
            }
            return 0;
          });
        }
  
        for (let i=0; i < response.products.length; i++) {
  
          let img_src = decodeHTML(response.products[i].img_src);
          let img = new Image();
          img.src = img_src;
          let img_link = document.createElement('a');
          img_link.setAttribute('href', `/products/${response.products[i].handle}`);
          img_link.setAttribute('target', '_blank');
          img_link.append(img);
          $(`[data-product-main-${i}]`).append(img_link);
  
          let title = decodeHTML(response.products[i].title);
          let title_element = document.createElement('a');
          title_element.setAttribute('href', `/products/${response.products[i].handle}`);
          title_element.setAttribute('target', '_blank');
          title_element.innerHTML = `<h4>${title}</h4>`;
          let sticky_title_element = title_element.cloneNode(true);
          $(`[data-product-list-${i}]`).text(title);
          $(`[data-product-main-${i}]`).append(title_element);
          $(`[data-sticky-title-${i}]`).append(sticky_title_element);
  
          let price = response.products[i].variant_price / 100;
          let price_element = document.createElement('div');
          price_element.innerText = `€${price.toFixed(2)}`;
          price_element.classList.add('price');
          let sticky_price_element = price_element.cloneNode(true);
          $(`[data-price-${i}]`).append(price_element);          	
          $(`[data-sticky-price-${i}]`).append(sticky_price_element);
  
          if (response.products[i].on_sale) {
            let sale_price = response.products[i].variant_compare_price / 100;
            let sale_price_element = document.createElement('div');
            sale_price_element.classList.add('compare-at-price');
            sale_price_element.classList.add('small');
            sale_price_element.innerText = `€${sale_price.toFixed(2)}`;
            let sticky_sale_price_element = sale_price_element.cloneNode(true);
            $(`[data-sticky-price-${i}]`).append(sale_price_element);
            $(`[data-price-${i}]`).append(sticky_sale_price_element);
          }
          else {
            $(`[data-sticky-price-${i}]`).css('alignItems', 'start');
            $(`[data-price-${i}]`).css('alignItems', 'start');
          }
  
          let stock_button = document.createElement('span');
          let stock_text = document.createElement('span');
          stock_button.classList.add('compare-stock-button');
          if (response.products[i].in_stock) {
            if (response.products[i].low_stock) {
              stock_button.style.color = '#FFB300';
              stock_button.innerHTML = '<i class="far fa-exclamation icon-padding-right"></i>';
              stock_text.style.color = '#FFB300';
              stock_text.innerText = 'Low stock';
            }
            else {
              stock_button.style.color = '#7CB342';
              stock_button.innerHTML = '<i class="far fa-check icon-padding-right"></i>';
              stock_text.style.color = '#7CB342';
              stock_text.innerText = 'In stock';
            }
          }
          else {
            stock_button.style.color = '#E53935';
            stock_button.innerHTML = '<i class="far fa-times icon-padding-right"></i>';
            stock_text.style.color = '#E53935';
            stock_text.innerText = 'Out of stock';
          }
          $(`[data-stock-${i}]`).append(stock_button);
          $(`[data-stock-${i}]`).append(stock_text);
  
          let cart_button = document.createElement('button');
          cart_button.classList.add('button');
          cart_button.classList.add('block-button');
          cart_button.classList.add('small-button');
          cart_button.classList.add('btn-add-to-cart');
          if (response.products[i].in_stock) {
            cart_button.innerText = 'Add to cart';
            cart_button.setAttribute('data-variant-id', response.products[i].variant_id);
          }
          else {
            cart_button.innerText = 'Out of stock';
            cart_button.classList.add('compare-out-of-stock-button');
            cart_button.classList.add('border-button');
            cart_button.classList.add('disabled');
          }
          let sticky_cart_button = cart_button.cloneNode(true);
          $(`[data-cart-${i}]`).append(cart_button);
          $(`[data-sticky-cart-${i}]`).append(sticky_cart_button);
  
          let features_html = document.createElement('div');
          features_html.innerHTML = response.products[i].features;
          $(`[data-features-${i}]`).append(features_html);
  
          if (response.products[i].specs && response.products[i].specs.length) {
            response.products[i].specs.forEach((spec) => {
              $(`[data-specs-${i}] [data-spec="${spec.name}"]`).text(spec.value);
            });
          }
  
          let reviews_html = document.createElement('div');
          reviews_html.innerHTML = `<a href= "/products/${response.products[i].handle}" target="_blank"><img alt="Feefo logo" border="0" src="https://api.feefo.com/api/logo?merchantidentifier=mcsport&vendorref=${response.products[i].variant_sku}&servicedefault=false&template=Product-Stars-White-Square-150x150.png" title="See what our customers say about this product"/></a>`;
          $(`[data-reviews-${i}]`).append(reviews_html);
  
        } 
        specs_rows.forEach((spec) => {
             equalSpecsHeights(spec); 
        });
        loader.hide();
      },
      error: function(response){
        console.log('error');
        console.log(response);
      },
      dataType: 'json'
    }); 
    
    fix_sticky();
    tooSmall();

    $(window).on("resize", function(e) {
      tooSmall();
    });

    $(window).on("scroll", function(e) {
      fix_sticky();
    });
    
    $('body').on('click', '#highlight-differences', function() {
      $(this).find('.switch').toggleClass('active');
      highlightDifferences();
    });
    
    $('body').on('click', '.compare-product-remove', function(e) {
      if (e.target.type == 'div') {
        target_col = e.target.dataset.col;
      }
      else {
        target_col = e.target.closest('div').dataset.col;
      }
      console.log(target_col);
      $(`[data-col-${target_col}]`).hide();
      $('.compare-page-grid').removeClass(`compare-grid-${num_products}`);
      num_products--;
      $('.compare-page-grid').addClass(`compare-grid-${num_products}`);
      $('.compare-expand').css('grid-column', `span ${num_products + 1}`);
      $('.compare-featspec-grid').css('grid-column', `span ${num_products + 1}`);
      $('.highlight-diff-slider').toggleClass('active');
      highlightDifferences();
      $('.highlight-diff-slider').toggleClass('active');
      highlightDifferences();
      if (num_products == 0) {
        compare_content_container.hide();
        compare_header.hide();
        compare_no_products_container.show();
      }
    });
    
    $('body').on('click', '.btn-add-to-cart', function() {
      let variant_id = $(this).data('variant-id');
      let qty = 1;
      let btnAddToCart = $(this);
      if (!$(this)[0].classList.contains('compare-out-of-stock-button')) {
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: 'quantity=' + qty + '&id=' + variant_id,
          dataType: 'json',
          beforeSend: function () {
            btnAddToCart.text('Adding...');
          },
          success: function (data) {
            // btnAddToCart.text('Added');
            location.reload();
            updateCartData(variant_id, qty);
          },
          error: function (xhr, text) {
            btnAddToCart.text('Add to cart');
          }
        });
      }
    });
    
    $('body').on('click', '.compare-expand', function() {
      let target = $(this).data('target');
      $(this).toggleClass('open closed');
      $(`.compare-table[data-target="${target}"]`).toggle();
    });
    
    $( window ).resize(function() {
      specs_rows.forEach((spec) => {
        equalSpecsHeights(spec); 
      });
    });
    
});  